import { render } from "./takeCandidateDocumentPhoto.vue?vue&type=template&id=fc4eb776&scoped=true"
import script from "./takeCandidateDocumentPhoto.vue?vue&type=script&lang=js"
export * from "./takeCandidateDocumentPhoto.vue?vue&type=script&lang=js"

import "./takeCandidateDocumentPhoto.vue?vue&type=style&index=0&id=fc4eb776&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc4eb776"]])

export default __exports__